/**
 * Ensures a lazily-registered Vuex module is available, registering it directly
 * if it isn't.
 *
 * Some Vuex modules (e.g. 'internal', 'admin', 'delivery') are registered
 * dynamically rather than being present from store creation. The live search
 * component (SearchBarFirestore.vue) only resolves route -> selectedSearch;
 * it does not register any Vuex modules. Each self-managed view (Organization,
 * Project, Time, Person) is responsible for ensuring its own 'internal'
 * module dependency is registered before dispatching into it - historically
 * done ad hoc per-view (and easy to forget, as Person.vue did), which is why
 * this lives as a single shared helper instead.
 *
 * @param {import('vuex').Store} store The Vuex store instance ($store).
 * @param {string} namespace The module namespace to ensure (e.g. 'internal').
 * @return {Promise<boolean>} Whether the module is registered when this resolves.
 */
const ensureModuleRegistered = async (store, namespace) => {
  if (store.hasModule(namespace)) {
    return true
  }

  try {
    await store.dispatch('registerModule', namespace)
  } catch (error) {
    if (!store.hasModule(namespace)) {
      // eslint-disable-next-line no-console
      console.error(`[ensureModuleRegistered] Failed to register '${namespace}' module:`, error)
      return false
    }
  }

  return store.hasModule(namespace)
}

export default ensureModuleRegistered
